import { Location } from 'react-router-dom';

/**
 * @param {Location} location - React router dom location
 * @param {string} userId - The userId, passed as a string
 * @returns {string} the attendee page URL
 */
export const formatParticipantURL = (location: Location, userId?: string) => {
  if (!userId) {
    return '';
  }
  const pathname = location.pathname; // Example: "/adboard/uuid/engagement"
  const pathParts = pathname.split('/').filter(Boolean); // removes empty strings

  // Build basePath: /adboard/{adboardId}
  const basePath = `/${pathParts[0]}/${pathParts[1]}`;

  return `${basePath}/participants/${userId}`;
};
